import { Stack, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { Controller, type FieldPath, useFormContext } from 'react-hook-form';
import { segmentedToggleSx } from 'src/pages/Settings/memberships/components/landing-page-tab/styled';
import { type LandingPageFormValues } from 'src/pages/Settings/memberships/components/landing-page-tab/types';
import { panelFieldLabelSx } from 'src/pages/Settings/memberships/styles';

interface SegmentedToggleFieldProps<TValue extends string> {
  name: FieldPath<LandingPageFormValues>;
  label: string;
  options: readonly { value: TValue; label: string }[];
  readOnly: boolean;
}

export const SegmentedToggleField = <TValue extends string>({
  name,
  label,
  options,
  readOnly,
}: SegmentedToggleFieldProps<TValue>) => {
  const { control } = useFormContext<LandingPageFormValues>();

  return (
    <Stack gap={1}>
      <Typography variant="caption" sx={panelFieldLabelSx}>
        {label}
      </Typography>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <ToggleButtonGroup
            exclusive
            fullWidth
            size="small"
            disabled={readOnly}
            value={field.value}
            onChange={(_, next: TValue | null) => {
              if (next) {
                field.onChange(next);
              }
            }}
            aria-label={label}
          >
            {options.map((option) => (
              <ToggleButton key={option.value} value={option.value} sx={segmentedToggleSx}>
                {option.label}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        )}
      />
    </Stack>
  );
};
